import { useMemo } from "react";
import { AuditTableCellState } from "./AuditTableCellState";
import { IAuditTableRow } from "./AuditEventsCheck";
import _ from "lodash";
import moment from "moment-timezone";

interface IAuditTableCellProps {
  data: IAuditTableRow;
  cellId: string;
}

const getColor = (obj: object, path: string): string => {
  const modifiedField = _.get(obj, path);
  return modifiedField ? "orange" : "inherit";
};

export const AuditTableCell = (props: IAuditTableCellProps): JSX.Element => {
  const { data, cellId } = props;

  const value = useMemo(() => {
    return _.get(data, cellId);
  }, [data, cellId]);

  switch (cellId) {
    case "state":
      return <AuditTableCellState row={data} />;

    case "ocFlight[flightNumber]":
    case "importedFlight[flightNumber]":
      return <p style={{ color: getColor(data.modifiedFields, "flightNumber") }}>{value}</p>;
    case "ocFlight[aircraft][registration]":
      return <p style={{ color: getColor(data.modifiedFields, "aircraft.registration") }}>{value}</p>;
    case "ocFlight[origin]":
      return <p style={{ color: getColor(data.modifiedFields, "origin") }}>{value}</p>;
    case "ocFlight[destination]":
      return <p style={{ color: getColor(data.modifiedFields, "destination") }}>{value}</p>;
    case "ocFlight[actualOut]":
      return (
        <p style={{ color: getColor(data.modifiedFields, "actualOut") }}>{value ? moment.utc(value).format() : null}</p>
      );
    case "ocFlight[actualIn]":
      return (
        <p style={{ color: getColor(data.modifiedFields, "actualIn") }}>{value ? moment.utc(value).format() : null}</p>
      );
    //IMPORTED
    case "importedFlight[aircraft][registration]":
      return <p style={{ color: getColor(data.modifiedFields, "aircraft.registration") }}>{value}</p>;
    case "importedFlight[origin]":
      return <p style={{ color: getColor(data.modifiedFields, "origin") }}>{value}</p>;
    case "importedFlight[destination]":
      return <p style={{ color: getColor(data.modifiedFields, "destination") }}>{value}</p>;
    case "importedFlight[actualOut]":
      return (
        <p style={{ color: getColor(data.modifiedFields, "actualOut") }}>{value ? moment.utc(value).format() : null}</p>
      );
    case "importedFlight[actualIn]":
      return (
        <p style={{ color: getColor(data.modifiedFields, "actualIn") }}>{value ? moment.utc(value).format() : null}</p>
      );

    default:
      return <p>Not Found</p>;
  }
};
